export const IT_CELLPHONE_PATTERN: string | RegExp = `^((00|\\+)39[\\. ]??)??3\\d{2}[\\. ]??\\d{6,7}$`;
